(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kh-dispatch-copy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-dispatch-range')) {
  customElements.define('kh-dispatch-range', class extends HTMLElement {
    connectedCallback() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      const value = (type) => Number(parts.find((part) => part.type === type).value);
      const start = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      const end = new Date(start);
      start.setUTCDate(start.getUTCDate() + 28);
      end.setUTCDate(end.getUTCDate() + 42);
      const format = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' });
      this.querySelector('span').textContent = format.format(start) + '–' + format.format(end);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-earring-purchase-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-earring-purchase-details')) {
  customElements.define('kh-earring-purchase-details', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.onChange = () => this.updateSelection();
      this.onViewEar = () => this.viewOnEar();
      this.productInfo?.addEventListener('change', this.onChange);
      this.querySelector('[data-view-ear]')?.addEventListener('click', this.onViewEar);
      const price = this.productInfo?.querySelector('[id="price-' + this.dataset.sectionId + '"]');
      if (price) {
        this.priceObserver = new MutationObserver(() => this.updateSelection());
        this.priceObserver.observe(price, { childList: true, subtree: true });
      }
      this.updateSelection();
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.querySelector('[data-view-ear]')?.removeEventListener('click', this.onViewEar);
      this.priceObserver?.disconnect();
    }
    selectedOption(name) {
      const picker = this.productInfo?.querySelector('variant-selects');
      if (!picker) return '';
      for (const select of picker.querySelectorAll('select')) {
        if (select.name === 'options[' + name + ']') return select.value;
      }
      for (const fieldset of picker.querySelectorAll('fieldset')) {
        const label = fieldset.querySelector('legend')?.textContent.trim() || '';
        if (label === name || label.startsWith(name + ':')) return fieldset.querySelector('input:checked')?.value || '';
      }
      return '';
    }
    updateSelection() {
      const weight = this.selectedOption(this.dataset.weightOption);
      const metal = this.selectedOption(this.dataset.metalOption);
      if (weight) this.querySelector('[data-earring-weight]').textContent = weight;
      if (metal) this.querySelector('[data-earring-metal]').textContent = metal;
    }
    viewOnEar() {
      const gallery = this.productInfo?.querySelector('media-gallery');
      if (!gallery) return;
      const items = Array.from(gallery.querySelectorAll('.product__media-item'));
      const target = items.find(item => /on.?ear|worn|model/i.test(item.querySelector('img')?.alt || '')) || items[5];
      if (!target) return;
      const thumbnail = Array.from(gallery.querySelectorAll('button[data-target]')).find(button => button.dataset.target === target.dataset.mediaId);
      if (thumbnail) thumbnail.click();
      else if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(target.dataset.mediaId, true);
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-editable-solitaire-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-editable-solitaire-purchase')) {
    customElements.define('kh-editable-solitaire-purchase', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.positionSelectedPrice();
        this.sectionId = this.dataset.sectionId;
        this.dimensionsTarget = document.getElementById('KhDiamondDimensions-' + this.sectionId)?.querySelector('[data-summary-dimensions]');
        this.priceSource = document.getElementById('price-' + this.sectionId);
        this.ringSize = this.productInfo?.querySelector('select[name="properties[Ring size]"]');
        this.mobileBar = this.querySelector('[data-mobile-purchase-bar]');
        if (this.mobileBar) document.body.append(this.mobileBar);
        this.onChange = event => {
          if(event.target?.matches('select[name="properties[Ring size]"]')) {
            const internal=Array.from(this.productInfo.querySelectorAll('variant-selects select')).find(select => select.name === 'options[' + this.dataset.sizeOption + ']');
            const chosen=event.target.value;
            const value=Array.from(internal?.options||[]).some(o=>o.value===chosen)?chosen:this.dataset.otherSize;
            if(internal && internal.value!==value){internal.value=value;internal.dispatchEvent(new Event('change',{bubbles:true}));}
          }
          window.setTimeout(() => this.update(), 0);
        };
        this.productInfo?.addEventListener('change', this.onChange);
        this.querySelector('[data-view-worn]')?.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('kh:view-worn'));
        });
        this.onMainAdd = (event) => {
          if (!this.isConcierge()) {
            const form = this.findAddButton()?.form;
            if (form && !form.reportValidity()) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign(this.dataset.conciergeUrl);
        };
        this.findAddButton()?.addEventListener('click', this.onMainAdd, true);
        this.mobileBar?.querySelector('[data-mobile-add]')?.addEventListener('click', event => {
          if (!this.isConcierge()) return;
          event.preventDefault();
          window.location.assign(this.dataset.conciergeUrl);
        });
        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.update());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }
        this.observeAddButton();
        this.update();
      }

      positionSelectedPrice() {
        const price = this.productInfo?.querySelector('.kh-selection-price')?.parentElement;
        const purchase = this.productInfo?.querySelector('product-form');
        if (this.dataset.shape?.startsWith('landscape ')) {
          const sizing = this.productInfo?.querySelector('.kh-ring-size');
          if (price && sizing && price.nextElementSibling !== sizing) sizing.before(price);
        } else {
          if (price && purchase && price.nextElementSibling !== purchase) purchase.before(price);
        }
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.findAddButton()?.removeEventListener('click', this.onMainAdd, true);
        this.mobileBar?.remove();
      }

      selectedOption(label, fallback) {
        if (!this.productInfo) return fallback;
        for (const fieldset of this.productInfo.querySelectorAll('fieldset.product-form__input')) {
          const legend = fieldset.querySelector('legend');
          if (legend?.textContent.trim().toLowerCase() === label.toLowerCase()) {
            return fieldset.querySelector('input:checked')?.value || fallback;
          }
        }
        for (const select of this.productInfo.querySelectorAll('.product-form__input select')) {
          const optionLabel = select.closest('.product-form__input')?.querySelector('label')?.textContent || '';
          if (optionLabel.trim().toLowerCase().includes(label.toLowerCase())) return select.value || fallback;
        }
        return fallback;
      }

      currentPrice() {
        return this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim()
          || this.querySelector('[data-summary-price]')?.textContent.trim()
          || '';
      }

      update() {
        const size = this.selectedOption(this.dataset.diamondOption, '');
        const concierge = size === '5ct+' || size.toLowerCase().includes('concierge');
        const displaySize = concierge ? this.dataset.conciergeLabel : size;
        const metal = this.selectedOption(this.dataset.metalOption, '');
        const ringSize = this.productInfo.querySelector('select[name="properties[Ring size]"]')?.value || '';
        const bank=this.productInfo.querySelector('kh-solitaire-gallery');
        const worn=bank?.config?.banks?.find(b=>b.carat===size&&b.metal===metal)?.images?.[5];
        const handButton=this.querySelector('[data-view-worn]');if(handButton)handButton.hidden=!worn;
        const dimensions = {};
        const price = this.currentPrice();
        const ringSizeText = ringSize ? (/advise/i.test(ringSize) ? ringSize : 'Size ' + ringSize.replace(' 1/2','½')) : this.dataset.sizePrompt;
        this.querySelector('[data-summary-selection]').textContent = displaySize + ' '+this.dataset.shape+' · ' + metal + ' · ' + ringSizeText;

        const mobileSelection = this.mobileBar?.querySelector('[data-mobile-selection]');
        const mobilePrice = this.mobileBar?.querySelector('[data-mobile-price]');
        if (mobileSelection) mobileSelection.textContent = displaySize + ' · ' + metal;
        if (mobilePrice) mobilePrice.textContent = concierge ? this.dataset.consultationLabel : price;
        this.querySelector('[data-summary-dispatch-dates]').textContent = this.dispatchDates();
        this.renameAddButton();
      }

      dispatchDates() {
        const weeks = (this.dataset.dispatchDuration || '').match(/\d+/g);
        const minimum = weeks && weeks.length ? Number(weeks[0]) : 4;
        const maximum = weeks && weeks.length > 1 ? Number(weeks[1]) : (weeks && weeks.length ? minimum : 6);
        const earliest = new Date();
        const latest = new Date();
        earliest.setDate(earliest.getDate() + minimum * 7);
        latest.setDate(latest.getDate() + maximum * 7);
        const format = new Intl.DateTimeFormat('en-GB', { day:'numeric', month:'long' });
        return format.format(earliest) + '–' + format.format(latest);
      }

      findAddButton() {
        return this.productInfo?.querySelector('.product-form__submit');
      }

      isConcierge() {
        const size = this.selectedOption(this.dataset.diamondOption, '');
        return size === '5ct+' || size.toLowerCase().includes('concierge');
      }

      renameAddButton() {
        const button = this.findAddButton();
        const concierge = this.isConcierge();
        if (concierge && button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
        const label = button?.querySelector('span');
        const targetLabel = concierge ? this.dataset.enquireLabel : this.dataset.addLabel;
        if (label && (concierge || !button.disabled) && label.textContent.trim() !== targetLabel) label.textContent = targetLabel;
        const mobileButton = this.mobileBar?.querySelector('[data-mobile-add]');
        const mobileLabel = concierge ? this.dataset.enquireLabel : (button?.disabled ? label?.textContent.trim() : this.dataset.addLabel);
        const unavailable = !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
        if (mobileButton && mobileButton.disabled !== unavailable) mobileButton.disabled = unavailable;
        if (mobileButton && mobileButton.textContent.trim() !== mobileLabel) mobileButton.textContent = mobileLabel;
      }

      observeAddButton() {
        const button = this.findAddButton();
        if (!button || !this.mobileBar) return;
        this.renameAddButton();
        this.buttonObserver = new MutationObserver(() => this.renameAddButton());
        this.buttonObserver.observe(button, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const hasPassed = entry.boundingClientRect.top < 0;
          const visible = !entry.isIntersecting && hasPassed;
          this.mobileBar.classList.toggle('is-visible', visible);
          this.mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        this.visibilityObserver.observe(button);
      }

    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-emerald-trilogy-purchase-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-emerald-trilogy-purchase-experience')) {
    customElements.define('kh-emerald-trilogy-purchase-experience', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.positionSelectedPrice();
        this.sectionId = this.dataset.sectionId;
        this.diamondSelect = this.productInfo?.querySelector('select[name="options[Diamond Size]"]');
        this.onConciergeChoice = (event) => {
          const select = event.target;
          if (!select.matches('select[name="options[Diamond Size]"]') || select.value !== 'private-concierge') return;
          event.stopImmediatePropagation();
          select.value = '10 × 8 mm emerald-cut';
          window.location.assign('/pages/contact');
        };
        this.productInfo?.addEventListener('change', this.onConciergeChoice, true);
        this.dimensionsTarget = document.getElementById('KhDiamondDimensions-' + this.sectionId)?.querySelector('[data-summary-dimensions]');
        this.priceSource = document.getElementById('price-' + this.sectionId);
        this.ringSize = document.getElementById('RingSize-' + this.sectionId);
        this.mobileBar = this.querySelector('[data-mobile-purchase-bar]');
        if (this.mobileBar) document.body.append(this.mobileBar);
        this.onChange = () => window.setTimeout(() => this.update(), 0);
        this.productInfo?.addEventListener('change', this.onChange);
        this.querySelector('[data-view-worn]')?.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('kh:view-worn'));
        });
        this.onMainAdd = (event) => {
          if (!this.isConcierge()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign('/pages/contact');
        };
        this.findAddButton()?.addEventListener('click', this.onMainAdd, true);
        this.mobileBar?.querySelector('[data-mobile-add]')?.addEventListener('click', () => this.submit());
        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.update());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }
        this.observeAddButton();
        this.update();
      }

      positionSelectedPrice() {
        const price = this.productInfo?.querySelector('.kh-selection-price');
        const ringSize = this.productInfo?.querySelector('.kh-ring-size');
        if (price && ringSize && price.nextElementSibling !== ringSize) ringSize.before(price);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.productInfo?.removeEventListener('change', this.onConciergeChoice, true);
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.findAddButton()?.removeEventListener('click', this.onMainAdd, true);
        this.mobileBar?.remove();
      }

      selectedOption(label, fallback) {
        if (!this.productInfo) return fallback;
        for (const fieldset of this.productInfo.querySelectorAll('fieldset.product-form__input')) {
          const legend = fieldset.querySelector('legend');
          if (legend?.textContent.trim().toLowerCase() === label.toLowerCase()) {
            return fieldset.querySelector('input:checked')?.value || fallback;
          }
        }
        for (const select of this.productInfo.querySelectorAll('.product-form__input select')) {
          const optionLabel = select.closest('.product-form__input')?.querySelector('label')?.textContent || '';
          if (optionLabel.trim().toLowerCase().includes(label.toLowerCase())) return select.value || fallback;
        }
        return fallback;
      }

      currentPrice() {
        return this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim()
          || this.querySelector('[data-summary-price]')?.textContent.trim()
          || '';
      }

      update() {
        const size = this.selectedOption('Diamond Size', '10 × 8 mm emerald-cut');
        const concierge = size === '5ct+' || size.toLowerCase().includes('concierge');
        const displaySize = concierge ? '4ct+ · Private concierge' : size;
        const metal = this.selectedOption('Metal', '18k Yellow Gold');
        const ringSize = this.ringSize?.value || '';
        const price = this.currentPrice();
        const ringSizeText = ringSize ? 'Size ' + ringSize : 'Select ring size';
        this.querySelector('[data-summary-selection]').textContent = displaySize + ' centre · ' + metal + ' · ' + ringSizeText;
        
        const mobileSelection = this.mobileBar?.querySelector('[data-mobile-selection]');
        const mobilePrice = this.mobileBar?.querySelector('[data-mobile-price]');
        if (mobileSelection) mobileSelection.textContent = displaySize + ' · ' + metal;
        if (mobilePrice) mobilePrice.textContent = concierge ? 'By consultation' : price;
        this.querySelector('[data-summary-dispatch-dates]').textContent = this.dispatchDates();
        this.renameAddButton();
      }

      dispatchDates() {
        const earliest = new Date();
        const latest = new Date();
        earliest.setDate(earliest.getDate() + 28);
        latest.setDate(latest.getDate() + 42);
        const format = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long' });
        return format.format(earliest) + '–' + format.format(latest);
      }

      findAddButton() {
        return this.productInfo?.querySelector('.product-form__submit');
      }

      isConcierge() {
        const size = this.selectedOption('Diamond Size', '10 × 8 mm emerald-cut');
        return size === '5ct+' || size.toLowerCase().includes('concierge');
      }

      renameAddButton() {
        const button = this.findAddButton();
        const concierge = this.isConcierge();
        if (concierge && button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
        const label = button?.querySelector('span');
        const targetLabel = concierge ? 'Private concierge' : this.dataset.addLabel;
        if (label && label.textContent.trim() !== targetLabel) label.textContent = targetLabel;
        const mobileButton = this.mobileBar?.querySelector('[data-mobile-add]');
        const mobileLabel = concierge ? 'Enquire' : this.dataset.addLabel;
        if (mobileButton && mobileButton.textContent.trim() !== mobileLabel) mobileButton.textContent = mobileLabel;
      }

      observeAddButton() {
        const button = this.findAddButton();
        if (!button || !this.mobileBar) return;
        this.renameAddButton();
        this.buttonObserver = new MutationObserver(() => this.renameAddButton());
        this.buttonObserver.observe(button, { childList: true, subtree: true, characterData: true });
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const hasPassed = entry.boundingClientRect.top < 0;
          const visible = !entry.isIntersecting && hasPassed;
          this.mobileBar.classList.toggle('is-visible', visible);
          this.mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        this.visibilityObserver.observe(button);
      }

      submit() {
        if (this.isConcierge()) {
          window.location.assign('/pages/contact');
          return;
        }
        if (this.ringSize && !this.ringSize.reportValidity()) {
          this.ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.findAddButton()?.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-oval-purchase-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-oval-purchase-experience')) {
    customElements.define('kh-oval-purchase-experience', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.positionSelectedPrice();
        this.sectionId = this.dataset.sectionId;
        this.dimensionsTarget = document.getElementById('KhDiamondDimensions-' + this.sectionId)?.querySelector('[data-summary-dimensions]');
        this.priceSource = document.getElementById('price-' + this.sectionId);
        this.ringSize = document.getElementById('RingSize-' + this.sectionId);
        this.mobileBar = this.querySelector('[data-mobile-purchase-bar]');
        if (this.mobileBar) document.body.append(this.mobileBar);
        this.onChange = () => window.setTimeout(() => this.update(), 0);
        this.productInfo?.addEventListener('change', this.onChange);
        this.querySelector('[data-view-worn]')?.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('kh:view-worn'));
        });
        this.onMainAdd = (event) => {
          if (!this.isConcierge()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign('/pages/contact');
        };
        this.findAddButton()?.addEventListener('click', this.onMainAdd, true);
        this.mobileBar?.querySelector('[data-mobile-add]')?.addEventListener('click', () => this.submit());
        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.update());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }
        this.observeAddButton();
        this.update();
      }

      positionSelectedPrice() {
        const price = this.productInfo?.querySelector('.kh-selection-price');
        const ringSize = this.productInfo?.querySelector('.kh-ring-size');
        if (price && ringSize && price.nextElementSibling !== ringSize) ringSize.before(price);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.findAddButton()?.removeEventListener('click', this.onMainAdd, true);
        this.mobileBar?.remove();
      }

      selectedOption(label, fallback) {
        if (!this.productInfo) return fallback;
        for (const fieldset of this.productInfo.querySelectorAll('fieldset.product-form__input')) {
          const legend = fieldset.querySelector('legend');
          if (legend?.textContent.trim().toLowerCase() === label.toLowerCase()) {
            return fieldset.querySelector('input:checked')?.value || fallback;
          }
        }
        for (const select of this.productInfo.querySelectorAll('.product-form__input select')) {
          const optionLabel = select.closest('.product-form__input')?.querySelector('label')?.textContent || '';
          if (optionLabel.trim().toLowerCase().includes(label.toLowerCase())) return select.value || fallback;
        }
        return fallback;
      }

      currentPrice() {
        return this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim()
          || this.querySelector('[data-summary-price]')?.textContent.trim()
          || '';
      }

      update() {
        const size = this.selectedOption('Diamond Size', '1ct');
        const concierge = size === '5ct+' || size.toLowerCase().includes('concierge');
        const displaySize = concierge ? '4ct+ · Private concierge' : size;
        const metal = this.selectedOption('Metal', '18k Yellow Gold');
        const ringSize = this.ringSize?.value || '';
        const dimensions = {
          '1ct': 'Typical face-up size around 8.0 × 5.7 mm',
          '1.5ct': 'Typical face-up size around 9.0 × 6.4 mm',
          '2ct': 'Typical face-up size around 10.0 × 7.0 mm',
          '2.5ct': 'Typical face-up size around 10.7 × 7.5 mm',
          '3ct': 'Typical face-up size around 11.5 × 8.0 mm',
          '4ct': 'Typical face-up size around 12.5 × 8.8 mm',
          '4ct+': 'Designed individually with our private client team'
        };
        const price = this.currentPrice();
        const ringSizeText = ringSize ? 'Size ' + ringSize : 'Select ring size';
        this.querySelector('[data-summary-selection]').textContent = displaySize + ' oval · ' + metal + ' · ' + ringSizeText;
        if (this.dimensionsTarget) this.dimensionsTarget.textContent = concierge ? dimensions['4ct+'] : (dimensions[size] || 'Exact face-up measurements confirmed before setting');
        const mobileSelection = this.mobileBar?.querySelector('[data-mobile-selection]');
        const mobilePrice = this.mobileBar?.querySelector('[data-mobile-price]');
        if (mobileSelection) mobileSelection.textContent = displaySize + ' · ' + metal;
        if (mobilePrice) mobilePrice.textContent = concierge ? 'By consultation' : price;
        this.querySelector('[data-summary-dispatch-dates]').textContent = this.dispatchDates();
        this.renameAddButton();
      }

      dispatchDates() {
        const earliest = new Date();
        const latest = new Date();
        earliest.setDate(earliest.getDate() + 28);
        latest.setDate(latest.getDate() + 42);
        const format = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long' });
        return format.format(earliest) + '–' + format.format(latest);
      }

      findAddButton() {
        return this.productInfo?.querySelector('.product-form__submit');
      }

      isConcierge() {
        const size = this.selectedOption('Diamond Size', '1ct');
        return size === '5ct+' || size.toLowerCase().includes('concierge');
      }

      renameAddButton() {
        const button = this.findAddButton();
        const concierge = this.isConcierge();
        if (concierge && button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
        const label = button?.querySelector('span');
        const targetLabel = concierge ? 'Private concierge' : 'Add to bag';
        if (label && label.textContent.trim() !== targetLabel) label.textContent = targetLabel;
        const mobileButton = this.mobileBar?.querySelector('[data-mobile-add]');
        const mobileLabel = concierge ? 'Enquire' : 'Add to bag';
        if (mobileButton && mobileButton.textContent.trim() !== mobileLabel) mobileButton.textContent = mobileLabel;
      }

      observeAddButton() {
        const button = this.findAddButton();
        if (!button || !this.mobileBar) return;
        this.renameAddButton();
        this.buttonObserver = new MutationObserver(() => this.renameAddButton());
        this.buttonObserver.observe(button, { childList: true, subtree: true, characterData: true });
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const hasPassed = entry.boundingClientRect.top < 0;
          const visible = !entry.isIntersecting && hasPassed;
          this.mobileBar.classList.toggle('is-visible', visible);
          this.mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        this.visibilityObserver.observe(button);
      }

      submit() {
        if (this.isConcierge()) {
          window.location.assign('/pages/contact');
          return;
        }
        if (this.ringSize && !this.ringSize.reportValidity()) {
          this.ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.findAddButton()?.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-princess-trilogy-purchase-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-princess-trilogy-purchase-experience')) {
    customElements.define('kh-princess-trilogy-purchase-experience', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.positionSelectedPrice();
        this.sectionId = this.dataset.sectionId;
        this.diamondSelect = this.productInfo?.querySelector('select[name="options[Diamond Size]"]');
        this.onConciergeChoice = (event) => {
          if (this.diamondSelect.value !== 'private-concierge') return;
          event.stopImmediatePropagation();
          this.diamondSelect.value = '2.5ct';
          window.location.assign('/pages/contact');
        };
        this.diamondSelect?.addEventListener('change', this.onConciergeChoice, true);
        this.dimensionsTarget = document.getElementById('KhDiamondDimensions-' + this.sectionId)?.querySelector('[data-summary-dimensions]');
        this.priceSource = document.getElementById('price-' + this.sectionId);
        this.ringSize = document.getElementById('RingSize-' + this.sectionId);
        this.mobileBar = this.querySelector('[data-mobile-purchase-bar]');
        if (this.mobileBar) document.body.append(this.mobileBar);
        this.onChange = () => window.setTimeout(() => this.update(), 0);
        this.productInfo?.addEventListener('change', this.onChange);
        this.querySelector('[data-view-worn]')?.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('kh:view-worn'));
        });
        this.onMainAdd = (event) => {
          if (!this.isConcierge()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign('/pages/contact');
        };
        this.findAddButton()?.addEventListener('click', this.onMainAdd, true);
        this.mobileBar?.querySelector('[data-mobile-add]')?.addEventListener('click', () => this.submit());
        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.update());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }
        this.observeAddButton();
        this.update();
      }

      positionSelectedPrice() {
        const price = this.productInfo?.querySelector('.kh-selection-price');
        const ringSize = this.productInfo?.querySelector('.kh-ring-size');
        if (price && ringSize && price.nextElementSibling !== ringSize) ringSize.before(price);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.diamondSelect?.removeEventListener('change', this.onConciergeChoice, true);
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.findAddButton()?.removeEventListener('click', this.onMainAdd, true);
        this.mobileBar?.remove();
      }

      selectedOption(label, fallback) {
        if (!this.productInfo) return fallback;
        for (const fieldset of this.productInfo.querySelectorAll('fieldset.product-form__input')) {
          const legend = fieldset.querySelector('legend');
          if (legend?.textContent.trim().toLowerCase() === label.toLowerCase()) {
            return fieldset.querySelector('input:checked')?.value || fallback;
          }
        }
        for (const select of this.productInfo.querySelectorAll('.product-form__input select')) {
          const optionLabel = select.closest('.product-form__input')?.querySelector('label')?.textContent || '';
          if (optionLabel.trim().toLowerCase().includes(label.toLowerCase())) return select.value || fallback;
        }
        return fallback;
      }

      currentPrice() {
        return this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim()
          || this.querySelector('[data-summary-price]')?.textContent.trim()
          || '';
      }

      update() {
        const size = this.selectedOption('Diamond Size', '2.5ct');
        const concierge = size === '5ct+' || size.toLowerCase().includes('concierge');
        const displaySize = concierge ? '4ct+ · Private concierge' : size;
        const metal = this.selectedOption('Metal', '18k Yellow Gold');
        const ringSize = this.ringSize?.value || '';
        
        const price = this.currentPrice();
        const ringSizeText = ringSize ? 'Size ' + ringSize : 'Select ring size';
        this.querySelector('[data-summary-selection]').textContent = displaySize + ' centre · ' + metal + ' · ' + ringSizeText;
        if (this.dimensionsTarget) this.dimensionsTarget.textContent = '2.5ct princess-cut centre';
        const mobileSelection = this.mobileBar?.querySelector('[data-mobile-selection]');
        const mobilePrice = this.mobileBar?.querySelector('[data-mobile-price]');
        if (mobileSelection) mobileSelection.textContent = displaySize + ' · ' + metal;
        if (mobilePrice) mobilePrice.textContent = concierge ? 'By consultation' : price;
        this.querySelector('[data-summary-dispatch-dates]').textContent = this.dispatchDates();
        this.renameAddButton();
      }

      dispatchDates() {
        const earliest = new Date();
        const latest = new Date();
        earliest.setDate(earliest.getDate() + 28);
        latest.setDate(latest.getDate() + 42);
        const format = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long' });
        return format.format(earliest) + '–' + format.format(latest);
      }

      findAddButton() {
        return this.productInfo?.querySelector('.product-form__submit');
      }

      isConcierge() {
        const size = this.selectedOption('Diamond Size', '2.5ct');
        return size === '5ct+' || size.toLowerCase().includes('concierge');
      }

      renameAddButton() {
        const button = this.findAddButton();
        const concierge = this.isConcierge();
        if (concierge && button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
        const label = button?.querySelector('span');
        const targetLabel = concierge ? 'Private concierge' : 'Add to bag';
        if (label && label.textContent.trim() !== targetLabel) label.textContent = targetLabel;
        const mobileButton = this.mobileBar?.querySelector('[data-mobile-add]');
        const mobileLabel = concierge ? 'Enquire' : 'Add to bag';
        if (mobileButton && mobileButton.textContent.trim() !== mobileLabel) mobileButton.textContent = mobileLabel;
      }

      observeAddButton() {
        const button = this.findAddButton();
        if (!button || !this.mobileBar) return;
        this.renameAddButton();
        this.buttonObserver = new MutationObserver(() => this.renameAddButton());
        this.buttonObserver.observe(button, { childList: true, subtree: true, characterData: true });
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const hasPassed = entry.boundingClientRect.top < 0;
          const visible = !entry.isIntersecting && hasPassed;
          this.mobileBar.classList.toggle('is-visible', visible);
          this.mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        this.visibilityObserver.observe(button);
      }

      submit() {
        if (this.isConcierge()) {
          window.location.assign('/pages/contact');
          return;
        }
        if (this.ringSize && !this.ringSize.reportValidity()) {
          this.ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.findAddButton()?.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-product-media-protection"] && !Shopify.designMode) return;
  try {
    (() => {
    const protectedMediaSelector = [
      '.product__media-wrapper img',
      '.product-media-modal img',
      '.oval-variant-gallery img',
      '.product__media-wrapper video',
      '.product-media-modal video',
      '.oval-variant-gallery video'
    ].join(',');

    const isProtectedMedia = (target) => target instanceof Element && target.closest(protectedMediaSelector);

    document.addEventListener('contextmenu', (event) => {
      if (isProtectedMedia(event.target)) event.preventDefault();
    });

    document.addEventListener('dragstart', (event) => {
      if (isProtectedMedia(event.target)) event.preventDefault();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-round-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-round-gallery')) {
  customElements.define('kh-round-gallery',class extends HTMLElement {
    connectedCallback() {
      this.images=JSON.parse(this.querySelector('[data-round-images]').textContent);
      this.main=this.querySelector('[data-main-image]');
      this.index=0;
      this.info=this.closest('product-info');
      this.change=()=>this.update();
      this.info.addEventListener('change',this.change);
      this.querySelectorAll('[data-gallery-index]').forEach(button=>button.addEventListener('click',()=>{this.index=Number(button.dataset.galleryIndex);this.update();}));
      this.startX=null;
      this.main.addEventListener('touchstart',event=>{this.startX=event.touches[0].clientX;},{passive:true});
      this.main.addEventListener('touchend',event=>{if(this.startX===null)return;const delta=event.changedTouches[0].clientX-this.startX;if(Math.abs(delta)>40){this.index=(this.index+(delta<0?1:-1)+this.images.yellow.length)%this.images.yellow.length;this.update();}this.startX=null;},{passive:true});
      this.update();
    }
    update() {
      const metal=this.info.querySelector('fieldset input[name^="Metal"]:checked')?.value
        ||this.info.querySelector('input[name^="Metal"]:checked')?.value
        ||this.info.querySelector('select[name="options[Metal]"]')?.value
        ||'18k Yellow Gold';
      const bank=metal==='18k Yellow Gold'?this.images.yellow:this.images.white;
      this.main.src=bank[this.index]||bank[0];
      this.main.alt='Round brilliant solitaire in '+metal+', studio view '+(this.index+1);
      this.querySelectorAll('[data-gallery-index]').forEach(button=>{
        const index=Number(button.dataset.galleryIndex);
        button.setAttribute('aria-current',String(index===this.index));
        const image=button.querySelector('img');
        image.removeAttribute('srcset');
        image.src=bank[index]||bank[0];
      });
    }
    disconnectedCallback(){this.info?.removeEventListener('change',this.change);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-round-purchase-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-round-purchase-experience')) {
    customElements.define('kh-round-purchase-experience', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.positionSelectedPrice();
        this.sectionId = this.dataset.sectionId;
        this.dimensionsTarget = document.getElementById('KhDiamondDimensions-' + this.sectionId)?.querySelector('[data-summary-dimensions]');
        this.priceSource = document.getElementById('price-' + this.sectionId);
        this.ringSize = this.productInfo?.querySelector('select[name="options[Ring Size]"], select[name="options[Ring size]"]');
        this.mobileBar = this.querySelector('[data-mobile-purchase-bar]');
        if (this.mobileBar) document.body.append(this.mobileBar);
        this.onChange = () => window.setTimeout(() => this.update(), 0);
        this.productInfo?.addEventListener('change', this.onChange);
        this.querySelector('[data-view-worn]')?.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('kh:view-worn'));
        });
        this.onMainAdd = (event) => {
          if (!this.isConcierge()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign('/pages/contact?subject=Diamond%20Concierge%20Service');
        };
        this.findAddButton()?.addEventListener('click', this.onMainAdd, true);
        this.mobileBar?.querySelector('[data-mobile-add]')?.addEventListener('click', () => this.submit());
        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.update());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }
        this.observeAddButton();
        this.update();
      }

      positionSelectedPrice() {
        const price = this.productInfo?.querySelector('.kh-selection-price');
        const ringSize = this.productInfo?.querySelector('.kh-ring-size');
        if (price && ringSize && price.nextElementSibling !== ringSize) ringSize.before(price);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.findAddButton()?.removeEventListener('click', this.onMainAdd, true);
        this.mobileBar?.remove();
      }

      selectedOption(label, fallback) {
        if (!this.productInfo) return fallback;
        for (const fieldset of this.productInfo.querySelectorAll('fieldset.product-form__input')) {
          const legend = fieldset.querySelector('legend');
          if (legend?.textContent.trim().toLowerCase() === label.toLowerCase()) {
            return fieldset.querySelector('input:checked')?.value || fallback;
          }
        }
        for (const select of this.productInfo.querySelectorAll('.product-form__input select')) {
          const optionLabel = select.closest('.product-form__input')?.querySelector('label')?.textContent || '';
          if (optionLabel.trim().toLowerCase().includes(label.toLowerCase())) return select.value || fallback;
        }
        return fallback;
      }

      currentPrice() {
        return this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim()
          || this.querySelector('[data-summary-price]')?.textContent.trim()
          || '';
      }

      update() {
        const size = this.selectedOption('Diamond Size', '1ct');
        const concierge = size === '5ct+' || size.toLowerCase().includes('concierge');
        const displaySize = concierge ? '4ct+ · Private concierge' : size;
        const metal = this.selectedOption('Metal', '18k Yellow Gold');
        const ringSize = this.selectedOption('Ring Size', '');
        const dimensions = {};
        const price = this.currentPrice();
        const ringSizeText = ringSize ? 'Size ' + ringSize : 'Select ring size';
        this.querySelector('[data-summary-selection]').textContent = displaySize + ' round brilliant · ' + metal + ' · ' + ringSizeText;
        if (this.dimensionsTarget) this.dimensionsTarget.textContent = 'Exact face-up measurements confirmed before setting';
        const mobileSelection = this.mobileBar?.querySelector('[data-mobile-selection]');
        const mobilePrice = this.mobileBar?.querySelector('[data-mobile-price]');
        if (mobileSelection) mobileSelection.textContent = displaySize + ' · ' + metal;
        if (mobilePrice) mobilePrice.textContent = concierge ? 'By consultation' : price;
        this.querySelector('[data-summary-dispatch-dates]').textContent = this.dispatchDates();
        this.renameAddButton();
      }

      dispatchDates() {
        const earliest = new Date();
        const latest = new Date();
        earliest.setDate(earliest.getDate() + 28);
        latest.setDate(latest.getDate() + 42);
        const format = new Intl.DateTimeFormat('en-GB', { day:'numeric', month:'long' });
        return format.format(earliest) + '–' + format.format(latest);
      }

      findAddButton() {
        return this.productInfo?.querySelector('.product-form__submit');
      }

      isConcierge() {
        const size = this.selectedOption('Diamond Size', '1ct');
        return size === '5ct+' || size.toLowerCase().includes('concierge');
      }

      renameAddButton() {
        const button = this.findAddButton();
        const concierge = this.isConcierge();
        if (concierge && button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
        const label = button?.querySelector('span');
        const targetLabel = concierge ? 'Private concierge' : 'Add to bag';
        if (label && label.textContent.trim() !== targetLabel) label.textContent = targetLabel;
        const mobileButton = this.mobileBar?.querySelector('[data-mobile-add]');
        const mobileLabel = concierge ? 'Enquire' : 'Add to bag';
        if (mobileButton && mobileButton.textContent.trim() !== mobileLabel) mobileButton.textContent = mobileLabel;
      }

      observeAddButton() {
        const button = this.findAddButton();
        if (!button || !this.mobileBar) return;
        this.renameAddButton();
        this.buttonObserver = new MutationObserver(() => this.renameAddButton());
        this.buttonObserver.observe(button, { childList: true, subtree: true, characterData: true });
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const hasPassed = entry.boundingClientRect.top < 0;
          const visible = !entry.isIntersecting && hasPassed;
          this.mobileBar.classList.toggle('is-visible', visible);
          this.mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        this.visibilityObserver.observe(button);
      }

      submit() {
        if (this.isConcierge()) {
          window.location.assign('/pages/contact?subject=Diamond%20Concierge%20Service');
          return;
        }
        if (this.ringSize && !this.ringSize.reportValidity()) {
          this.ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.findAddButton()?.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-solitaire-purchase-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-solitaire-purchase-experience')) {
    customElements.define('kh-solitaire-purchase-experience', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.sectionId = this.dataset.sectionId;
        this.shape = this.dataset.shapeLabel || 'solitaire';
        this.priceSource = document.getElementById('price-' + this.sectionId);
        this.mobileBar = this.querySelector('[data-mobile-purchase-bar]');
        if (this.mobileBar) document.body.append(this.mobileBar);
        this.onChange = () => window.setTimeout(() => this.update(), 0);
        this.productInfo?.addEventListener('change', this.onChange);
        this.querySelector('[data-view-worn]')?.addEventListener('click', () => this.viewOnHand());
        this.mobileBar?.querySelector('[data-mobile-add]')?.addEventListener('click', () => this.findAddButton()?.click());
        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.update());
          this.priceObserver.observe(this.priceSource, { childList:true, subtree:true, characterData:true });
        }
        this.observeAddButton();
        this.update();
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.mobileBar?.remove();
      }

      selectedOption(label, fallback) {
        if (!this.productInfo) return fallback;
        for (const fieldset of this.productInfo.querySelectorAll('fieldset.product-form__input')) {
          const legend = fieldset.querySelector('legend');
          if (legend?.textContent.trim().toLowerCase() === label.toLowerCase()) return fieldset.querySelector('input:checked')?.value || fallback;
        }
        for (const select of this.productInfo.querySelectorAll('.product-form__input select')) {
          const optionLabel = select.closest('.product-form__input')?.querySelector('label')?.textContent || '';
          if (optionLabel.trim().toLowerCase().includes(label.toLowerCase())) return select.value || fallback;
        }
        return fallback;
      }

      currentPrice() {
        return this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim() || '';
      }

      update() {
        const size = this.selectedOption('Diamond Size', '1ct');
        const metal = this.selectedOption('Metal', '18k Yellow Gold');
        const ringSize = this.selectedOption('Ring Size', 'Select ring size');
        const ringSizeText = !ringSize || ringSize === 'Select ring size' ? 'Select ring size' : 'Size ' + ringSize;
        const selection = size + ' ' + this.shape + ' · ' + metal + ' · ' + ringSizeText;
        const heading = this.querySelector('[data-summary-selection]');
        const mobileSelection = this.mobileBar?.querySelector('[data-mobile-selection]');
        const mobilePrice = this.mobileBar?.querySelector('[data-mobile-price]');
        if (heading) heading.textContent = selection;
        if (mobileSelection) mobileSelection.textContent = size + ' · ' + metal + ' · ' + ringSizeText;
        if (mobilePrice) mobilePrice.textContent = this.currentPrice();
        const dispatch = this.querySelector('[data-summary-dispatch-dates]');
        if (dispatch) dispatch.textContent = this.dispatchDates();
      }

      dispatchDates() {
        const earliest = new Date();
        const latest = new Date();
        earliest.setDate(earliest.getDate() + 28);
        latest.setDate(latest.getDate() + 42);
        const format = new Intl.DateTimeFormat('en-GB', { day:'numeric', month:'long' });
        return format.format(earliest) + '–' + format.format(latest);
      }

      findAddButton() {
        return this.productInfo?.querySelector('.product-form__submit');
      }

      observeAddButton() {
        const button = this.findAddButton();
        if (!button || !this.mobileBar) return;
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.mobileBar.classList.toggle('is-visible', visible);
          this.mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold:0 });
        this.visibilityObserver.observe(button);
      }

      viewOnHand() {
        const gallery = this.productInfo?.closest('main')?.querySelector('media-gallery');
        const handImage = gallery?.querySelector('[alt*="hand" i]');
        if (handImage) { handImage.click(); handImage.scrollIntoView({ behavior:'smooth', block:'center' }); return; }
        const lastThumbnail = gallery?.querySelector('.thumbnail-list__item:last-child button');
        if (lastThumbnail) lastThumbnail.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kh-trilogy-purchase-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kh-trilogy-purchase-experience')) {
    customElements.define('kh-trilogy-purchase-experience', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.positionSelectedPrice();
        this.sectionId = this.dataset.sectionId;
        this.diamondSelect = this.productInfo?.querySelector('select[name="options[Diamond Size]"]');
        this.onConciergeChoice = (event) => {
          if (this.diamondSelect.value !== 'private-concierge') return;
          event.stopImmediatePropagation();
          this.diamondSelect.value = '2.5ct';
          window.location.assign('/pages/contact');
        };
        this.diamondSelect?.addEventListener('change', this.onConciergeChoice, true);
        this.dimensionsTarget = document.getElementById('KhDiamondDimensions-' + this.sectionId)?.querySelector('[data-summary-dimensions]');
        this.priceSource = document.getElementById('price-' + this.sectionId);
        this.ringSize = document.getElementById('RingSize-' + this.sectionId);
        this.mobileBar = this.querySelector('[data-mobile-purchase-bar]');
        if (this.mobileBar) document.body.append(this.mobileBar);
        this.onChange = () => window.setTimeout(() => this.update(), 0);
        this.productInfo?.addEventListener('change', this.onChange);
        this.querySelector('[data-view-worn]')?.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('kh:view-worn'));
        });
        this.onMainAdd = (event) => {
          if (!this.isConcierge()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign('/pages/contact');
        };
        this.findAddButton()?.addEventListener('click', this.onMainAdd, true);
        this.mobileBar?.querySelector('[data-mobile-add]')?.addEventListener('click', () => this.submit());
        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.update());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }
        this.observeAddButton();
        this.update();
      }

      positionSelectedPrice() {
        const price = this.productInfo?.querySelector('.kh-selection-price');
        const ringSize = this.productInfo?.querySelector('.kh-ring-size');
        if (price && ringSize && price.nextElementSibling !== ringSize) ringSize.before(price);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.diamondSelect?.removeEventListener('change', this.onConciergeChoice, true);
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.findAddButton()?.removeEventListener('click', this.onMainAdd, true);
        this.mobileBar?.remove();
      }

      selectedOption(label, fallback) {
        if (!this.productInfo) return fallback;
        for (const fieldset of this.productInfo.querySelectorAll('fieldset.product-form__input')) {
          const legend = fieldset.querySelector('legend');
          if (legend?.textContent.trim().toLowerCase() === label.toLowerCase()) {
            return fieldset.querySelector('input:checked')?.value || fallback;
          }
        }
        for (const select of this.productInfo.querySelectorAll('.product-form__input select')) {
          const optionLabel = select.closest('.product-form__input')?.querySelector('label')?.textContent || '';
          if (optionLabel.trim().toLowerCase().includes(label.toLowerCase())) return select.value || fallback;
        }
        return fallback;
      }

      currentPrice() {
        return this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim()
          || this.querySelector('[data-summary-price]')?.textContent.trim()
          || '';
      }

      update() {
        const size = this.selectedOption('Diamond Size', '2.5ct');
        const concierge = size === '5ct+' || size.toLowerCase().includes('concierge');
        const displaySize = concierge ? '4ct+ · Private concierge' : size;
        const metal = this.selectedOption('Metal', '18k Yellow Gold');
        const ringSize = this.ringSize?.value || '';
        const dimensions = {
          '1ct': 'Typical face-up size around 8.0 × 5.5 mm',
          '1.5ct': 'Typical face-up size around 9.1 × 6.4 mm',
          '2ct': 'Typical face-up size around 10.1 × 7.0 mm',
          '2.5ct': 'Typical face-up size around 10.8 × 7.5 mm',
          '3ct': 'Typical face-up size around 11.5 × 8.0 mm',
          '4ct': 'Typical face-up size around 12.7 × 8.8 mm',
          '4ct+': 'Designed individually with our private client team'
        };
        const price = this.currentPrice();
        const ringSizeText = ringSize ? 'Size ' + ringSize : 'Select ring size';
        this.querySelector('[data-summary-selection]').textContent = displaySize + ' centre · ' + metal + ' · ' + ringSizeText;
        if (this.dimensionsTarget) this.dimensionsTarget.textContent = 'Typical face-up size around 10.8 × 7.5 mm';
        const mobileSelection = this.mobileBar?.querySelector('[data-mobile-selection]');
        const mobilePrice = this.mobileBar?.querySelector('[data-mobile-price]');
        if (mobileSelection) mobileSelection.textContent = displaySize + ' · ' + metal;
        if (mobilePrice) mobilePrice.textContent = concierge ? 'By consultation' : price;
        this.querySelector('[data-summary-dispatch-dates]').textContent = this.dispatchDates();
        this.renameAddButton();
      }

      dispatchDates() {
        const earliest = new Date();
        const latest = new Date();
        earliest.setDate(earliest.getDate() + 28);
        latest.setDate(latest.getDate() + 42);
        const format = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long' });
        return format.format(earliest) + '–' + format.format(latest);
      }

      findAddButton() {
        return this.productInfo?.querySelector('.product-form__submit');
      }

      isConcierge() {
        const size = this.selectedOption('Diamond Size', '2.5ct');
        return size === '5ct+' || size.toLowerCase().includes('concierge');
      }

      renameAddButton() {
        const button = this.findAddButton();
        const concierge = this.isConcierge();
        if (concierge && button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
        const label = button?.querySelector('span');
        const targetLabel = concierge ? 'Private concierge' : 'Add to bag';
        if (label && label.textContent.trim() !== targetLabel) label.textContent = targetLabel;
        const mobileButton = this.mobileBar?.querySelector('[data-mobile-add]');
        const mobileLabel = concierge ? 'Enquire' : 'Add to bag';
        if (mobileButton && mobileButton.textContent.trim() !== mobileLabel) mobileButton.textContent = mobileLabel;
      }

      observeAddButton() {
        const button = this.findAddButton();
        if (!button || !this.mobileBar) return;
        this.renameAddButton();
        this.buttonObserver = new MutationObserver(() => this.renameAddButton());
        this.buttonObserver.observe(button, { childList: true, subtree: true, characterData: true });
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          const hasPassed = entry.boundingClientRect.top < 0;
          const visible = !entry.isIntersecting && hasPassed;
          this.mobileBar.classList.toggle('is-visible', visible);
          this.mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }, { threshold: 0 });
        this.visibilityObserver.observe(button);
      }

      submit() {
        if (this.isConcierge()) {
          window.location.assign('/pages/contact');
          return;
        }
        if (this.ringSize && !this.ringSize.reportValidity()) {
          this.ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.findAddButton()?.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
